import {
  policy,
  items,
  backgroundStyle,
  image,
  primaryColor,
  tabColor,
  textColor,
  profileContentManagement,
  myAddress,
  subscriptionBuy,
  thirdPartyLogin,
  voucher,
  featuredProducts,
  titleTextColor,
} from './constant';

const backgroundStyleFields = [
  [backgroundStyle, image],
  [backgroundStyle, primaryColor],
  [backgroundStyle, tabColor],
  [backgroundStyle, textColor],
];

const policyFields = [[policy, items]];

const profileFields = [
  [profileContentManagement, myAddress],
  [profileContentManagement, subscriptionBuy],
  [profileContentManagement, thirdPartyLogin],
  [profileContentManagement, voucher],
];

const featureProducts = [[featuredProducts, titleTextColor]];

export { backgroundStyleFields, policyFields, profileFields, featureProducts };
